<template>
  <!-- MODAL Lighting -->
  <b-modal
    id="modalSLT"
    title="สถานะการทำงานของอุปกรณ์ไฟฟ้าแสงสว่าาง"
    size="xl"
    ok-only
    ok-title="ตกลง"
  >
    <b-row>
      <b-col
        cols="12"
        class="d-flex align-items-center justify-content-end mb-1"
      >
        <b-button
          v-b-modal="'addDevice'"
          variant="primary"
          class="btn-icon"
        >
          <feather-icon
            icon="PlusCircleIcon"
            size="18"
            class="mr-1"
          />
          <label style="color:white; font-size: 14px;">เพิ่มอุปกรณ์</label>
        </b-button>
      </b-col>
      <b-col
        cols="12"
      >      <b-card no-body>
        <!-- table -->
        <b-table
          responsive
          :per-page="perPage"
          :current-page="currentPage"
          :items="items"
          :fields="fields"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :sort-direction="sortDirection"
          :filter="filter"
          :filter-included-fields="filterOn"
          style="background-color:rgba(0, 22, 45, 0.1);"
          @filtered="onFiltered"
        >
          <template
            slot="thead-top"
          >
            <th
              colspan="1"
              style="text-align:center;font-size: 14px"
            />
          </template>
          <template
            #cell(id)="data"
          >
            <b-link
              v-b-modal="'editDevice'"
              @click="$refs.childref.sendInfo(data.item.id)"
            ><b-img
              src="@/assets/images/icons/Edit.svg"
            />
            </b-link>
            <b-link
              @click.prevent="remove(data.item.id)"
            >
              <b-img
                src="@/assets/images/icons/Delete.svg"
              />
            </b-link>
          </template>
          <template
            slot="thead-top"
          >
            <th
              colspan="3"
              style="text-align:center;font-size: 14px; background:rgb(255, 177, 0,0.7)"
            >
              แรงดันไฟฟ้า (Volt)
            </th>
          </template>
          <template
            slot="thead-top"
          >
            <th
              colspan="3"
              style="text-align:center;font-size: 14px; background:rgba(0, 188, 255, 0.7)"
            >
              กระแสไฟฟ้า (Amp)
            </th>
          </template>
          <template
            slot="thead-top"
          >
            <th
              colspan="4"
              style="text-align:center;font-size: 14px"
            />
          </template>
          <template #cell(devconnect)="data">
            <b-badge
              :variant="status[1][data.value]"
              style="font-size: 13px;"
            >
              {{ status[0][data.value] }}
            </b-badge>
          </template>
          <!-- <template #cell(devstatus)="data">
            <b-badge
              :variant="devstatus[1][data.value]"
              style="font-size: 13px;"
            >
              {{ devstatus[0][data.value] }}
            </b-badge>
          </template> -->
          <template #cell(devstatus)="data">
            <b-img
              v-if="data.item.devstatus == 'ดับ'"
              :src="require('@/assets/images/icons/lighting_icon_map1.png')"
              height="16"
            />
            <b-img
              v-if="data.item.devstatus == 'ปกติ'"
              :src="require('@/assets/images/icons/lighting_icon_map.png')"
              height="16"
            />
          </template>
        </b-table>
      </b-card></b-col>

      <addDevice @fetch="getSemDetail()" />
      <editDevice
        ref="childref"
        @fetch="getSemDetail()"
      />
    </b-row>
  </b-modal>
</template>

<script>
import axios from '@axios'
import {
  BRow, BCol, BCard, BTable,
  BBadge, BButton, BImg, BLink,
} from 'bootstrap-vue'
import addDevice from './adddevice/addlDevice.vue'
import editDevice from './adddevice/editDevice.vue'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BTable,
    BBadge,
    BImg,
    BButton,
    addDevice,
    editDevice,
    BLink,
  },
  data() {
    return {
      items: [],
      fields: [
        { key: 'pole', label: 'เสาไฟ', class: 'text-center' },
        {
          key: 'phase1_volt', label: 'phase 1', sortable: true, class: 'text-center', thStyle: { background: 'rgb(255, 177, 0,0.7)' }, tdClass: 'bg-light-warning',
        },
        {
          key: 'phase2_volt', label: 'phase 2', sortable: true, class: 'text-center', thStyle: { background: 'rgb(255, 177, 0,0.7)' }, tdClass: 'bg-light-warning',
        },
        {
          key: 'phase3_volt', label: 'phase 3', sortable: true, class: 'text-center', thStyle: { background: 'rgb(255, 177, 0,0.7)' }, tdClass: 'bg-light-warning',
        },
        {
          key: 'phase1_amp', label: 'phase 1', sortable: true, class: 'text-center', thStyle: { background: 'rgba(0, 188, 255, 0.7)' }, tdClass: 'bg-light-info',
        },
        {
          key: 'phase2_amp', label: 'phase 2', sortable: true, class: 'text-center', thStyle: { background: 'rgba(0, 188, 255, 0.7)' }, tdClass: 'bg-light-info',
        },
        {
          key: 'phase3_amp', label: 'phase 3', sortable: true, class: 'text-center', thStyle: { background: 'rgba(0, 188, 255, 0.7)' }, tdClass: 'bg-light-info',
        },
        {
          key: 'devstatus', label: 'การทำงาน', sortable: true, class: 'text-center',
        },
        // {
        //   key: 'devstate', label: 'สถานะ', sortable: true, class: 'text-center',
        // },
        {
          key: 'lastseen', label: 'อัพเดทล่าสุด', sortable: true, class: 'text-center',
        },
        {
          key: 'devconnect', label: 'การเชื่อมต่อ', sortable: true, class: 'text-center',
        },
        { key: 'id', label: 'การจัดการ', class: 'text-center' },
      ],
      perPage: '',
      totalRows: '',
      currentPage: 1,
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
      status: [{
        ติดต่อไม่ได้: 'ติดต่อไม่ได้', ปกติ: 'ปกติ',
      },
      {
        ติดต่อไม่ได้: 'light-danger', ปกติ: 'light-success',
      }],
      devstatus: [{
        ดับ: 'ดับ', ปกติ: 'ปกติ',
      },
      {
        ดับ: 'light-danger', ปกติ: 'light-success',
      }],
    }
  },
  beforeDestroy() {
    clearInterval(this.interval)
  },
  mounted() {
    this.getSemDetail()
    this.interval = setInterval(() => {
      this.getSemDetail()
    }, 300000)
  },
  methods: {
    getSemDetail() {
      axios
        .post('/markerSEMControlDetail', { wid: this.$route.query.wid })
        .then(response => {
          this.items = response.data
          this.totalRows = response.data.length
          this.perPage = response.data.length
        })
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    remove(uid) {
      console.log(uid)
      this.$swal({
        title: '<span style="color:#000000">ต้องการลบหรือไม่</span>',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'ตกลง',
        cancelButtonText: 'ยกเลิก',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(async result => {
        if (result.value) {
          try {
            const selectedID = uid
            await axios.post('/deleteDevice', { id: selectedID })
            this.$swal({
              icon: 'success',
              title: '<span style="color:#000000">ลบเรียบร้อยแล้ว</span>',
              // text: 'Deleted successfully.',
              showConfirmButton: false,
              timer: 1000,
            })
            this.getSemDetail()
          } catch (error) {
            this.$swal({
              title: 'Error!',
              text: 'กดเพื่อดำเนินการต่อ!',
              icon: 'error',
              customClass: {
                confirmButton: 'btn btn-primary',
              },
              buttonsStyling: false,
            })
          }
        }
      })
    },
    handleOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault()
      // Trigger submit handler
      this.validationForm()
    },
  },
}
</script>

<style>

</style>
